import React from 'react';

import IssuesPieContainer from './IssuesPieContainer';

const PieChartSwitch = ({ type, projectId }) => {
  switch (type) {
    case "issues":
      return <IssuesPieContainer projectId={projectId} />
    default:
      return <IssuesPieContainer projectId={projectId} />
  }
}

export default PieChartSwitch;



// WEBPACK FOOTER //
// ./src/views/Project/PieChart/PieChartSwitch.js